/** @jsx jsx */
import PropTypes from 'prop-types'
import { useLayoutEffect, useState } from 'react'
import { Box, jsx } from 'theme-ui'

const CollectionFilterBarFilter = ({
  title,
  slug,
  onClick,
  color,
  currentCollection,
}) => {
  const [isActive, setIsActive] = useState(null)
  const [isPastaActive, setIsPastaActive] = useState(null)
  const isDietary = slug?.toLowerCase().includes('dietary')
  const pillTitle = isDietary ? 'Dietary' : title
  const isPasta = slug?.toLowerCase() === 'pasta'

  useLayoutEffect(() => {
    setIsPastaActive(currentCollection?.slug === 'pasta')
    setIsActive(
      currentCollection?.slug === slug ||
        (!slug && !currentCollection?.slug && pillTitle === 'Shop All'),
    )
  }, [currentCollection?.slug, slug])

  return (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: isPastaActive ? '#007300' : '#00E0BE',
        border: [`${isActive ? 4 : 3}px solid`],
        borderRadius: '5em',
        borderColor: isActive
          ? isPastaActive
            ? '#00E0BE'
            : '#FFDD00'
          : '#007300',
        color: isPastaActive ? '#FFDD00' : '#007300',
        cursor: 'pointer',
        textAlign: 'center',
        minWidth: '150px',
        width: ['40%', 150],
        height: ['34px', '45px'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: ['0', '0'],
      }}
      variant="text.eyebrow.uppercase"
    >
      {pillTitle}
    </Box>
  )
}

CollectionFilterBarFilter.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string,
  onClick: PropTypes.func,
  currentCollection: PropTypes.shape({
    slug: PropTypes.string,
  }),
}

export default CollectionFilterBarFilter
